import React, { useRef, useEffect } from 'react'

import Spinner from 'js/components/Spinner/Spinner'

type Props = {
  id: any
  height: any
  width: any
  subheading?: React.ReactNode
  name?: React.ReactNode
  description?: React.ReactNode
  onPlay?: () => void
}

const VideoPlayer = ({
  id,
  height,
  width,
  subheading,
  name,
  description,
  onPlay = () => {},
}: Props) => {
  const ref = useRef<HTMLIFrameElement>(null)

  useEffect(() => {
    function listener() {
      if (document.activeElement === ref.current) {
        onPlay()
      }
      window.removeEventListener('blur', listener)
    }

    window.addEventListener('blur', listener)

    return () => window.removeEventListener('blur', listener)
  })

  if (!id)
    return (
      <div
        className="relative flex w-full overflow-hidden"
        style={{
          paddingTop: '65%',
        }}
      >
        <Spinner
          width="48"
          color="green"
          className="absolute left-1/2 top-1/2 -ml-24 -mt-24"
        />
      </div>
    )
  return (
    <>
      <div
        key={id}
        className="relative mb-16 w-full overflow-hidden rounded-8 lg:mb-24 lg:rounded-16"
        style={{
          paddingTop: (height / width) * 100 + '%',
        }}
      >
        <iframe
          className="absolute inset-0 h-full w-full rounded-6 lg:rounded-12"
          frameBorder="0"
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          src={`https://www.youtube.com/embed/${id}?modestbranding=1&rel=0`}
          ref={ref}
        />
      </div>
      <h2 className="mb-16">
        <span className="type-upper-fat mb-4 block text-green lg:mb-6">
          {subheading}
        </span>
        <span className="sr-only">{': '}</span>
        <span className="type-med-plus-fat capitalize">{name}</span>
      </h2>
      <p className="type-med-minus s-text max-w-768 leading-body">
        {description}
      </p>
    </>
  )
}

export default VideoPlayer
